module.exports = __webpack_public_path__ + "static/services-legacy-system-b36635250326dd4367a14d07496d36b6.svg";